export const errorMessageDefinitions = {
  GENERAL: {
    id: 'error.code.GENERAL',
    defaultMessage: 'An error occurred.',
  },
  VALIDATION: {
    id: 'error.code.VALIDATION',
    defaultMessage: 'Validation error',
  },
  DOMAIN_ERROR: {
    id: 'error.code.DOMAIN_ERROR',
    defaultMessage: 'An error occurred.',
  },
  ENTITY_NOT_FOUND: {
    id: 'error.code.ENTITY_NOT_FOUND',
    defaultMessage: 'Entity not found.',
  },
  ESTIMATION_ITEM_ASSUMPTION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_ASSUMPTION_NOT_FOUND',
    defaultMessage: 'Assumption not found.',
  },
  ESTIMATION_ITEM_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_NOT_FOUND',
    defaultMessage: 'Phase not found.',
  },
  ESTIMATION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_NOT_FOUND',
    defaultMessage: 'Estimation not found.',
  },
  PROJECT_TYPE_CURRENCY_NOT_FOUND: {
    id: 'error.code.PROJECT_TYPE_CURRENCY_NOT_FOUND',
    defaultMessage: 'Unsupported currency.',
  },
  PROJECT_TYPE_NOT_FOUND: {
    id: 'error.code.PROJECT_TYPE_NOT_FOUND',
    defaultMessage: 'Project type not found.',
  },
  PROJECT_NOT_FOUND: {
    id: 'error.code.PROJECT_NOT_FOUND',
    defaultMessage: 'Project not found.',
  },
  ESTIMATION_COST_NOT_FOUND: {
    id: 'error.code.ESTIMATION_COST_NOT_FOUND',
    defaultMessage: 'Estimation cost not found.',
  },
  RESOURCE_TYPE_COST_NOT_FOUND: {
    id: 'error.code.RESOURCE_TYPE_COST_NOT_FOUND',
    defaultMessage: 'Resource type not found.',
  },
  USER_NOT_FOUND: {
    id: 'error.code.USER_NOT_FOUND',
    defaultMessage: 'User not found.',
  },
  LOCALIZATION_NOT_FOUND: {
    id: 'error.code.LOCALIZATION_NOT_FOUND',
    defaultMessage: 'Localization not found.',
  },
  ESTIMATION_USER_ASSIGNMENT_NOT_FOUND: {
    id: 'error.code.ESTIMATION_USER_ASSIGNMENT_NOT_FOUND',
    defaultMessage: 'Estimation - User assingment not found.',
  },
  ESTIMATION_MODEL_ITEM_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_NOT_FOUND',
    defaultMessage: 'Estimation model item not found.',
  },
  ESTIMATION_ITEM_COMMENT_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_COMMENT_NOT_FOUND',
    defaultMessage: 'Phase comment not found.',
  },
  ESTIMATION_COMMENT_NOT_FOUND: {
    id: 'error.code.ESTIMATION_COMMENT_NOT_FOUND',
    defaultMessage: 'Estimation comment not found.',
  },
  COMMENT_BASE_NOT_FOUND: {
    id: 'error.code.COMMENT_BASE_NOT_FOUND',
    defaultMessage: 'Comment not found.',
  },
  TENANT_NOT_FOUND: {
    id: 'error.code.TENANT_NOT_FOUND',
    defaultMessage: 'Tenant not found.',
  },
  ROLE_NOT_FOUND: {
    id: 'error.code.ROLE_NOT_FOUND',
    defaultMessage: 'Role not found.',
  },
  PROJECT_NOTIFICATION_NOT_FOUND: {
    id: 'error.code.PROJECT_NOTIFICATION_NOT_FOUND',
    defaultMessage: 'Project notification not found.',
  },
  NOTIFICATION_BASE_NOT_FOUND: {
    id: 'error.code.NOTIFICATION_BASE_NOT_FOUND',
    defaultMessage: 'Notification not found.',
  },
  ESTIMATION_NOTIFICATION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_NOTIFICATION_NOT_FOUND',
    defaultMessage: 'Estimation notification not found.',
  },
  ESTIMATION_ITEM_NOTIFICATION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_NOTIFICATION_NOT_FOUND',
    defaultMessage: 'Phase notification not found.',
  },
  COMMENT_NOTIFICATION_NOT_FOUND: {
    id: 'error.code.COMMENT_NOTIFICATION_NOT_FOUND',
    defaultMessage: 'Comment notification not found.',
  },
  ESTIMATION_MODEL_UNIT_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_UNIT_NOT_FOUND',
    defaultMessage: 'Estimation model unit not found.',
  },
  ESTIMATION_MODEL_ITEM_PARAMETER_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_PARAMETER_NOT_FOUND',
    defaultMessage: 'Estimation model item parameter not found.',
  },
  ESTIMATION_MODEL_ASSUMPTION_CATEGORY_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_ASSUMPTION_CATEGORY_NOT_FOUND',
    defaultMessage: 'Assumption type not found.',
  },
  ESTIMATION_MODEL_ADDITIONAL_FIELD_DEFINITION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_ADDITIONAL_FIELD_DEFINITION_NOT_FOUND',
    defaultMessage: 'Metadata field not found.',
  },
  ESTIMATION_MODEL_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_NOT_FOUND',
    defaultMessage: 'Estimation model not found.',
  },
  METHODOLOGY_PARAMETER_NOT_FOUND: {
    id: 'error.code.METHODOLOGY_PARAMETER_NOT_FOUND',
    defaultMessage: 'Methodology parameter not found.',
  },
  METHODOLOGY_NOT_FOUND: {
    id: 'error.code.METHODOLOGY_NOT_FOUND',
    defaultMessage: 'Methodology not found.',
  },
  ESTIMATION_ITEM_RESOURCE_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_RESOURCE_NOT_FOUND',
    defaultMessage: 'Phase resource not found.',
  },
  ESTIMATION_ITEM_COST_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_COST_NOT_FOUND',
    defaultMessage: 'Phase cost not found.',
  },
  ESTIMATION_ITEM_PARAMETER_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ITEM_PARAMETER_NOT_FOUND',
    defaultMessage: 'Phase parameter not found.',
  },
  ESTIMATION_ASSUMPTION_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ASSUMPTION_NOT_FOUND',
    defaultMessage: 'Estimation assumption not found.',
  },
  ESTIMATION_ADDITIONAL_FIELD_NOT_FOUND: {
    id: 'error.code.ESTIMATION_ADDITIONAL_FIELD_NOT_FOUND',
    defaultMessage: 'Estimation metadata field not found.',
  },
  CURRENCY_CONVERSION_RATE_NOT_FOUND: {
    id: 'error.code.CURRENCY_CONVERSION_RATE_NOT_FOUND',
    defaultMessage: 'Currency conversion rate not found.',
  },
  ESTIMATION_MODEL_METHODOLOGY_NOT_FOUND: {
    id: 'error.code.ESTIMATION_MODEL_METHODOLOGY_NOT_FOUND',
    defaultMessage: 'Estimation model methodology not found.',
  },
  RESOURCE_TYPE_NOT_FOUND: {
    id: 'error.code.RESOURCE_TYPE_NOT_FOUND',
    defaultMessage: 'Resource type not found.',
  },
  COST_TYPE_NOT_FOUND: {
    id: 'error.code.COST_TYPE_NOT_FOUND',
    defaultMessage: 'Cost type not found.',
  },
  CURRENCY_NOT_FOUND: {
    id: 'error.code.CURRENCY_NOT_FOUND',
    defaultMessage: 'Currency not found.',
  },
  CALCULATION_FORMULA_EVALUATION_ERROR: {
    id: 'error.code.CALCULATION_FORMULA_EVALUATION_ERROR',
    defaultMessage: 'Calculation formula evaluation error.',
  },
  SUM_ITEMS_EXCEPT_ARGUMENTS_MUST_BE_QUOTED: {
    id: 'error.code.SUM_ITEMS_EXCEPT_ARGUMENTS_MUST_BE_QUOTED',
    defaultMessage:
      'sumItemsExcept function arguments must be quoted. Use sumItemsExcept(\'item1\', \'item2\') instead of sumItemsExcept(item1, item2).',
  },
  CALCULATION_MISSING_INPUT_DATA: {
    id: 'error.code.CALCULATION_MISSING_INPUT_DATA',
    defaultMessage: 'Calculation is missing input data.',
  },
  CALCULATION_MISSING_PARAMETER_VALUE: {
    id: 'error.code.CALCULATION_MISSING_PARAMETER_VALUE',
    defaultMessage: 'Calculation is missing parameter value.',
  },
  WRONG_ASSUMPTION_CATEGORY: {
    id: 'error.code.WRONG_ASSUMPTION_CATEGORY',
    defaultMessage: 'Wrong assumption type.',
  },
  WRONG_UNIT: {
    id: 'error.code.WRONG_UNIT',
    defaultMessage: 'Wrong estimation unit.',
  },
  WRONG_ESTIMATION_UNIT_PARENT: {
    id: 'error.code.WRONG_ESTIMATION_UNIT_PARENT',
    defaultMessage: 'Wrong estimation unit',
  },
  CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_PARAMS: {
    id: 'error.code.CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_PARAMS',
    defaultMessage: 'Calculated phase cannot have parameters.',
  },
  CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_METHODOLOGY: {
    id: 'error.code.CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_METHODOLOGY',
    defaultMessage: 'Calculated phase cannot have methodology.',
  },
  UNCALCULATED_ESTIMATION_ITEM_MUST_HAVE_PARAMS: {
    id: 'error.code.UNCALCULATED_ESTIMATION_ITEM_MUST_HAVE_PARAMS',
    defaultMessage: 'Modifiable phase must have parameters.',
  },
  METHODOLOGY_CANNOT_BE_SET_WHEN_MODEL_ITEM_HAS_PARAMS: {
    id: 'error.code.METHODOLOGY_CANNOT_BE_SET_WHEN_MODEL_ITEM_HAS_PARAMS',
    defaultMessage: 'Methodology cannot be set when the underlying model phase has parameters.',
  },
  METHODOLOGY_UNSUPPORTED_BY_MODEL: {
    id: 'error.code.METHODOLOGY_UNSUPPORTED_BY_MODEL',
    defaultMessage: 'The methodology is unsupported by the model.',
  },
  OMIT_REASON_CAN_ONLY_BE_SET_FOR_OMITTED_ESTIMATION_ITEM: {
    id: 'error.code.OMIT_REASON_CAN_ONLY_BE_SET_FOR_OMITTED_ESTIMATION_ITEM',
    defaultMessage: 'Omit reason can only be set for omitted phase.',
  },
  OMIT_REASON_MUST_BE_SET_FOR_OMITTED_ESTIMATION_ITEM: {
    id: 'error.code.OMIT_REASON_MUST_BE_SET_FOR_OMITTED_ESTIMATION_ITEM',
    defaultMessage: 'Omit reason must be set for required omitted phase.',
  },
  ESTIMATION_ADDITIONAL_FIELD_WRONG_DEFINITION: {
    id: 'error.code.ESTIMATION_ADDITIONAL_FIELD_WRONG_DEFINITION',
    defaultMessage: 'Wrong definition of the estimation metadata field.',
  },
  CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DURATION: {
    id: 'error.code.CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DURATION',
    defaultMessage: 'Cannot parse duration metadata field.',
  },
  ESTIMATION_ADDITIONAL_FIELD_OF_TYPE_SELECTABLE_CONTAINS_WRONG_VALUE: {
    id: 'error.code.ESTIMATION_ADDITIONAL_FIELD_OF_TYPE_SELECTABLE_CONTAINS_WRONG_VALUE',
    defaultMessage: 'Estimation selectable metadata field contains wrong value.',
  },

  USER_NOT_REVIEWER: {
    id: 'error.code.USER_NOT_REVIEWER',
    defaultMessage: 'The user is not reviewer.',
  },
  CALCULATION_FORMULA_MUST_BE_SET_FOR_METHODOLOGY: {
    id: 'error.code.CALCULATION_FORMULA_MUST_BE_SET_FOR_METHODOLOGY',
    defaultMessage: 'Calculation formula must be set for methodology.',
  },
  METHODOLOGY_MUST_HAVE_AT_LEAST_ONE_PARAMETER: {
    id: 'error.code.METHODOLOGY_MUST_HAVE_AT_LEAST_ONE_PARAMETER',
    defaultMessage: 'Methodology must have at least one parameter.',
  },
  CANNOT_DELETE_METHODOLOGY_IN_USE: {
    id: 'error.code.CANNOT_DELETE_METHODOLOGY_IN_USE',
    defaultMessage: 'Cannot delete methodology because it is used in estimation model(s).',
  },
  ESTIMATION_ITEM_BASED_ON_MODEL_CANNOT_HAVE_THIS_PARENT: {
    id: 'error.code.ESTIMATION_ITEM_BASED_ON_MODEL_CANNOT_HAVE_THIS_PARENT',
    defaultMessage: 'Phase based on model cannot have this parent phase.',
  },
  WRONG_ESTIMATION_ITEMS_PARAMETERS_COUNT: {
    id: 'error.code.WRONG_ESTIMATION_ITEMS_PARAMETERS_COUNT',
    defaultMessage: 'Wrong number of parameters for the phase.',
  },
  WRONG_CALCULATION_METHODOLOGY_FORMULA: {
    id: 'error.code.WRONG_CALCULATION_METHODOLOGY_FORMULA',
    defaultMessage: 'Methodology has wrong calculation formula.',
  },
  AI_INTEGRATION_UNEXPECTED_FINISH_REASON: {
    id: 'error.code.AI_INTEGRATION_UNEXPECTED_FINISH_REASON',
    defaultMessage: 'Unexpected finish reason in AI services.',
  },
  AI_INTEGRATION_NO_CONTENT: {
    id: 'error.code.AI_INTEGRATION_NO_CONTENT',
    defaultMessage: 'Missing content in AI integration.',
  },
  WRONG_RESOURCES_FOR_ESTIMATION_ITEM: {
    id: 'error.code.WRONG_RESOURCES_FOR_ESTIMATION_ITEM',
    defaultMessage: 'Wrong resource(s) for phase.',
  },
  WRONG_RESOURCE_TYPE_COSTS_FOR_ESTIMATION: {
    id: 'error.code.WRONG_RESOURCE_TYPE_COSTS_FOR_ESTIMATION',
    defaultMessage: 'Wrong resource type costs for estimation.',
  },
  CANNOT_DEFINE_COSTS_WHEN_THERE_ARE_NO_RESOURCE_TYPES_DEFINED: {
    id: 'error.code.CANNOT_DEFINE_COSTS_WHEN_THERE_ARE_NO_RESOURCE_TYPES_DEFINED',
    defaultMessage: 'Costs cannot be defined when there are no resource types defined.',
  },
  ESTIMATION_ITEM_FOR_ESTIMATION_MODEL_ITEM_MUST_HAVE_SAME_GROUP_AS_THE_MODEL_ITEM: {
    id: 'error.code.ESTIMATION_ITEM_FOR_ESTIMATION_MODEL_ITEM_MUST_HAVE_SAME_GROUP_AS_THE_MODEL_ITEM',
    defaultMessage: 'Model based phase must have same group as the model phase definition.',
  },
  WRONG_ESTIMATION_MODEL_GROUP_ID: {
    id: 'error.code.WRONG_ESTIMATION_MODEL_GROUP_ID',
    defaultMessage: 'Wrong estimation model group.',
  },
  UNAUTHORIZED_USER_ACCESS: {
    id: 'error.code.UNAUTHORIZED_USER_ACCESS',
    defaultMessage: 'Unauthorized user access.',
  },
  USER_PROVISIONING_MISSING_EMAIL_CLAIM: {
    id: 'error.code.USER_PROVISIONING_MISSING_EMAIL_CLAIM',
    defaultMessage:
      "We're sorry, but your login doesn't contain an email address. Please contact your administrator.",
  },
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_COMBINATION_OF_PARENT_ID_ORDER_AND_PURPOSE: {
    id: 'error.code.ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_COMBINATION_OF_PARENT_ID_ORDER_AND_PURPOSE',
    defaultMessage:
      'Estimation model phase definitions having same parent cannot have same order and purpose defined.',
  },
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_REF_KEY: {
    id: 'error.code.ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_REF_KEY',
    defaultMessage: 'Estimation model phase definitions cannot have same reference key.',
  },
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_CALCULATION_REF: {
    id: 'error.code.ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_CALCULATION_REF',
    defaultMessage: 'Estimation model phase definitions cannot have same reference name.',
  },
  ESTIMATION_MODEL_WITH_SAME_PROJECT_TYPE_BUT_DIFFERENT_REF_KEY_EXISTS: {
    id: 'error.code.ESTIMATION_MODEL_WITH_SAME_PROJECT_TYPE_BUT_DIFFERENT_REF_KEY_EXISTS',
    defaultMessage: 'Estimation model with same project type but different ref_key exists.',
  },
  ESTIMATION_MUST_BE_APPROVED_WHEN_CREATING_NEW_VERSION: {
    id: 'error.code.ESTIMATION_MUST_BE_APPROVED_WHEN_CREATING_NEW_VERSION',
    defaultMessage: 'Estimation must be completed when creating a new version.',
  },
  CALCULATION_FORMULA_MUST_BE_PROVIDED_WHEN_HAVING_MULTIPLE_PARAMETERS: {
    id: 'error.code.CALCULATION_FORMULA_MUST_BE_PROVIDED_WHEN_HAVING_MULTIPLE_PARAMETERS',
    defaultMessage:
      'Calculation formula must be provided when there are multiple parameters defined.',
  },
  TENANT_NOT_AVAILABLE: {
    id: 'error.code.TENANT_NOT_AVAILABLE',
    defaultMessage: 'The tenant is unavailable.',
  },
  GRAPH_API_EMPTY_USER_RESULT: {
    id: 'error.code.GRAPH_API_EMPTY_USER_RESULT',
    defaultMessage: 'Graph API returned empty user.',
  },
  CANNOT_PARSE_GRAPH_API_USER_ID: {
    id: 'error.code.CANNOT_PARSE_GRAPH_API_USER_ID',
    defaultMessage: 'Cannot parse Graph API user ID.',
  },
  CANNOT_CHANGE_ESTIMATION_ITEM_METHODOLOGY_ON_CHILD_ITEM: {
    id: 'error.code.CANNOT_CHANGE_ESTIMATION_ITEM_METHODOLOGY_ON_CHILD_ITEM',
    defaultMessage: 'Cannot change estimation item methodology on sub-item.',
  },
  CANNOT_CREATE_INITIAL_ESTIMATION_ITEMS_WHEN_ANY_ITEMS_ALREADY_EXIST: {
    id: 'error.code.CANNOT_CREATE_INITIAL_ESTIMATION_ITEMS_WHEN_ANY_ITEMS_ALREADY_EXIST',
    defaultMessage: 'Cannot create initial estimation items when any items already exist',
  },
  ESTIMATION_ITEM_PARAMETER_VALUES_COUNT_MISMATCH: {
    id: 'error.code.ESTIMATION_ITEM_PARAMETER_VALUES_COUNT_MISMATCH',
    defaultMessage: 'Estimation item parameter values count does not match',
  },
  ESTIMATION_ITEM_PARAMETER_CREATION_FAILED: {
    id: 'error.code.ESTIMATION_ITEM_PARAMETER_CREATION_FAILED',
    defaultMessage: 'Estimation item parameter creation failed.',
  },
  PUBLISHED_ESTIMATION_MODEL_CANNOT_BE_UNPUBLISHED: {
    id: 'error.code.PUBLISHED_ESTIMATION_MODEL_CANNOT_BE_UNPUBLISHED',
    defaultMessage: 'Cannot unpublish the estimation model that has already been published.',
  },
  DUPLICATE_METHODOLOGY_ID_IN_ESTIMATION_MODEL: {
    id: 'error.code.DUPLICATE_METHODOLOGY_ID_IN_ESTIMATION_MODEL',
    defaultMessage: 'Duplicate methodology id in estimation model.',
  },
  ESTIMATION_MODEL_UNIT_MISMATCH: {
    id: 'error.code.ESTIMATION_MODEL_UNIT_MISMATCH',
    defaultMessage: 'Units must be related to estimation model.',
  },
  DUPLICATE_ESTIMATION_UNIT_IN_ESTIMATION_MODEL: {
    id: 'error.code.DUPLICATE_ESTIMATION_UNIT_IN_ESTIMATION_MODEL',
    defaultMessage: 'Duplicate estimation unit in estimation model.',
  },
  ESTIMATION_MODEL_ADDITIONAL_FIELD_TYPE_MUST_BE_SELECTABLE: {
    id: 'error.code.ESTIMATION_MODEL_ADDITIONAL_FIELD_TYPE_MUST_BE_SELECTABLE',
    defaultMessage: 'Estimation model metadata type must be selectable.',
  },
  ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTIONS_MUST_NOT_BE_EMPTY: {
    id: 'error.code.ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTIONS_MUST_NOT_BE_EMPTY',
    defaultMessage: 'Estimation model metadata options must not be empty.',
  },
  ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTION_MUST_NOT_CONTAIN_PIPE: {
    id: 'error.code.ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTION_MUST_NOT_CONTAIN_PIPE',
    defaultMessage: 'Selectable option cannot contain character "|"',
  },
  SELF_REFERENCING_PARENT_ERROR: {
    id: 'error.code.SELF_REFERENCING_PARENT_ERROR',
    defaultMessage: 'Self referencing parent.',
  },
  CALCULATION_FORMULA_MISSING: {
    id: 'error.code.CALCULATION_FORMULA_MISSING',
    defaultMessage: 'Calculation formula is missing.',
  },
  INVALID_CALCULATION_REFERENCE: {
    id: 'error.code.INVALID_CALCULATION_REFERENCE',
    defaultMessage: 'Invalid calculation reference',
  },
  FILTER_COMBINATION_IS_NOT_SUPPORTED: {
    id: 'error.code.FILTER_COMBINATION_IS_NOT_SUPPORTED',
    defaultMessage: 'The filter combination is unsupported.',
  },
  PARENT_AND_CHILD_COMMENT_DISCRIMINATOR_TYPE_MISMATCH: {
    id: 'error.code.PARENT_AND_CHILD_COMMENT_DISCRIMINATOR_TYPE_MISMATCH',
    defaultMessage: 'Mismatch in comment type.',
  },
  WRONG_COSTS_FOR_ESTIMATION_ITEM: {
    id: 'error.code.WRONG_COSTS_FOR_ESTIMATION_ITEM',
    defaultMessage: 'Wrong costs for estimation item.',
  },
  ESTIMATION_MODEL_ITEM_HAS_RECURSIVE_FORMULA_REFERENCE: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_HAS_RECURSIVE_FORMULA_REFERENCE',
    defaultMessage: 'Estimation model item has recursive formula reference.',
  },
  ESTIMATION_MODEL_ITEM_HAS_WRONG_FORMULA_REFERENCE: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_HAS_WRONG_FORMULA_REFERENCE',
    defaultMessage: 'Estimation model item has wrong formula reference.',
  },
  ESTIMATION_MODEL_ITEM_HAS_MISSING_FORMULA_PARAMETERS: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_HAS_MISSING_FORMULA_PARAMETERS',
    defaultMessage: 'Estimation model item has missing formula parameters.',
  },
  ESTIMATION_MODEL_ITEM_REFERENCES_NON_EXISTING_ITEM: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_REFERENCES_NON_EXISTING_ITEM',
    defaultMessage:
      'Estimation model item references non-existing item in its formula. Please check formulas and reference names.',
  },
  DECIMAL_VALUE_TOO_MANY_DIGITS: {
    id: 'error.code.DECIMAL_VALUE_TOO_MANY_DIGITS',
    defaultMessage: 'Decimal value has too many digits.',
  },
  DECIMAL_VALUE_TOO_MANY_DECIMAL_DIGITS: {
    id: 'error.code.DECIMAL_VALUE_TOO_MANY_DECIMAL_DIGITS',
    defaultMessage: 'Decimal value has too many decimal digits.',
  },
  CANNOT_SET_PARAMETERS_ON_ITEM_WITH_COST_PURPOSE: {
    id: 'error.code.CANNOT_SET_PARAMETERS_ON_ITEM_WITH_COST_PURPOSE',
    defaultMessage: 'Cannot set parameters on item with cost purpose.',
  },
  ESTIMATION_ITEM_PURPOSE_MUST_MATCH_ITS_ESTIMATION_MODEL_ITEM_PURPOSE: {
    id: 'error.code.ESTIMATION_ITEM_PURPOSE_MUST_MATCH_ITS_ESTIMATION_MODEL_ITEM_PURPOSE',
    defaultMessage: 'Estimation item purpose must match its estimation model item purpose.',
  },
  CANNOT_SET_METHODOLOGY_ON_ITEM_WITH_COST_PURPOSE: {
    id: 'error.code.CANNOT_SET_METHODOLOGY_ON_ITEM_WITH_COST_PURPOSE',
    defaultMessage: 'Cannot set methodology on estimation item with cost purpose.',
  },
  ESTIMATION_ITEM_OF_COST_PURPOSE_CANNOT_HAVE_CALCULATED_RESULT: {
    id: 'error.code.ESTIMATION_ITEM_OF_COST_PURPOSE_CANNOT_HAVE_CALCULATED_RESULT',
    defaultMessage: 'Estimation item of cost purpose cannot have calculated result.',
  },
  PARENT_ESTIMATION_ITEM_PURPOSE_MUST_MATCH: {
    id: 'error.code.PARENT_ESTIMATION_ITEM_PURPOSE_MUST_MATCH',
    defaultMessage: 'Parent estimation item purpose must match.',
  },
  ESTIMATION_MODEL_ITEM_PARENT_PURPOSE_MUST_MATCH: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_PARENT_PURPOSE_MUST_MATCH',
    defaultMessage: 'Estimation model item parent purpose must match.',
  },
  CANNOT_SET_METHODOLOGY_ON_ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE: {
    id: 'error.code.CANNOT_SET_METHODOLOGY_ON_ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE',
    defaultMessage: 'Cannot set methodology on estimation model item with cost purpose.',
  },
  ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_CALCULATION_FORMULA: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_CALCULATION_FORMULA',
    defaultMessage: 'Estimation model item with cost purpose cannot have calculation formula.',
  },
  ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_PARAMETERS: {
    id: 'error.code.ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_PARAMETERS',
    defaultMessage: 'Estimation model item with cost purpose cannot have parameters.',
  },
  CANNOT_ASSIGN_RESOURCE_TO_ESTIMATION_ITEM_WITH_COST_PURPOSE: {
    id: 'error.code.CANNOT_ASSIGN_RESOURCE_TO_ESTIMATION_ITEM_WITH_COST_PURPOSE',
    defaultMessage: 'Cannot assign resource to estimation item with cost purpose.',
  },
  CALCULATED_ESTIMATION_MODEL_ITEM_CANNOT_HAVE_PARAMETER_WITH_NULL_VALUE: {
    id: 'error.code.CALCULATED_ESTIMATION_MODEL_ITEM_CANNOT_HAVE_PARAMETER_WITH_NULL_VALUE',
    defaultMessage: 'Calculated estimation model item cannot have parameter with unset value',
  },
  ESTIMATION_STAGE_MUST_BE_IN_REVIEW_WHEN_CHANGING_TO_APPROVED_STAGE: {
    id: 'error.code.ESTIMATION_STAGE_MUST_BE_IN_REVIEW_WHEN_CHANGING_TO_APPROVED_STAGE',
    defaultMessage: 'Estimation stage must be in review when changing to approved stage.',
  },
  ESTIMATION_STAGE_MUST_BE_IN_PROCESS_WHEN_CHANGING_TO_IN_REVIEW_STAGE: {
    id: 'error.code.ESTIMATION_STAGE_MUST_BE_IN_PROCESS_WHEN_CHANGING_TO_IN_REVIEW_STAGE',
    defaultMessage: 'Estimation stage must be in process when changing to in review stage.',
  },
  ESTIMATION_STAGE_MUST_BE_IN_CREATION_OR_IN_REVIEW_WHEN_CHANGING_TO_IN_PROCESS_STAGE: {
    id: 'error.code.ESTIMATION_STAGE_MUST_BE_IN_CREATION_OR_IN_REVIEW_WHEN_CHANGING_TO_IN_PROCESS_STAGE',
    defaultMessage:
      'Estimation stage must be in creation or in review when changing to in process stage.',
  },
  CANNOT_UPDATE_ESTIMATION_WHEN_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPDATE_ESTIMATION_WHEN_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage: 'Cannot update estimation when stage is in review or approved.',
  },
  CANNOT_UPDATE_ESTIMATION_ADDITIONAL_FIELDS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPDATE_ESTIMATION_ADDITIONAL_FIELDS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation metadata fields when estimation stage is in review or approved.',
  },
  CANNOT_UPSERT_ESTIMATION_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPSERT_ESTIMATION_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation costs when estimation stage is in review or approved.',
  },
  CANNOT_CREATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_CREATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage: 'Cannot create estimation item when estimation stage is in review or approved.',
  },
  CANNOT_UPSERT_ESTIMATION_ITEMS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPSERT_ESTIMATION_ITEMS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation items when estimation stage is in review or approved.',
  },
  CANNOT_UPDATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPDATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage: 'Cannot update estimation item when estimation stage is in review or approved.',
  },
  CANNOT_DELETE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_DELETE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage: 'Cannot delete estimation item when estimation stage is in review or approved.',
  },
  CANNOT_CREATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_CREATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot create estimation item assumption when estimation stage is in review or approved.',
  },
  CANNOT_UPDATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPDATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation item assumption when estimation stage is in review or approved.',
  },
  CANNOT_DELETE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_DELETE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot delete estimation item assumption when estimation stage is in review or approved.',
  },
  CANNOT_UPSERT_ESTIMATION_ITEM_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPSERT_ESTIMATION_ITEM_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation item costs when estimation stage is in review or approved.',
  },
  CANNOT_UPSERT_ESTIMATION_ITEM_RESOURCES_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED: {
    id: 'error.code.CANNOT_UPSERT_ESTIMATION_ITEM_RESOURCES_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
    defaultMessage:
      'Cannot update estimation item resources when estimation stage is in review or approved.',
  },
  CANNOT_DELETE_ESTIMATION_ITEM_WITH_ESTIMATION_MODEL_ITEM: {
    id: 'error.code.CANNOT_DELETE_ESTIMATION_ITEM_WITH_ESTIMATION_MODEL_ITEM',
    defaultMessage: 'Cannot delete estimation item with estimation model item.',
  },
  CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DATE: {
    id: 'error.code.CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DATE',
    defaultMessage: 'Date master data are in wrong format.',
  },
  CANNOT_COMMENT_WHEN_ESTIMATION_IS_NOT_IN_REVIEW: {
    id: 'error.code.CANNOT_COMMENT_WHEN_ESTIMATION_IS_NOT_IN_REVIEW',
    defaultMessage: 'Cannot comment when estimation is not in review.',
  },
  THERE_MUST_BE_EXACTLY_ONE_PLANNING_RESPONSIBLE_FOR_ESTIMATION: {
    id: 'error.code.THERE_MUST_BE_EXACTLY_ONE_PLANNING_RESPONSIBLE_FOR_ESTIMATION',
    defaultMessage: 'There must be exactly one planning responsible per estimation.',
  },
  CANNOT_DELETE_USER_WHEN_IS_PLANNING_RESPONSIBLE: {
    id: 'error.code.CANNOT_DELETE_USER_WHEN_IS_PLANNING_RESPONSIBLE',
    defaultMessage:
      'User is assigned as planning responsible on estimation(s) therefore cannot be deleted.',
  },
  EVERY_PHASE_LEAD_MUST_BE_ASSIGNED_AS_CONTRIBUTOR_OR_PLANNING_RESPONSIBLE_TO_ESTIMATION: {
    id: 'error.code.EVERY_PHASE_LEAD_MUST_BE_ASSIGNED_AS_CONTRIBUTOR_OR_PLANNING_RESPONSIBLE_TO_ESTIMATION',
    defaultMessage: 
        'Every phase lead must be assigned as contributor or a planning responsible to the estimation.',
    },
  AI_SERVICE_ERROR: {
    id: "error.code.AI_SERVICE_ERROR",
    defaultMessage:
      "An error occurred with the AI service. Please try again later.",
  },
  UPLOAD_FILE_EMPTY: {
    id: 'error.code.UPLOAD_FILE_EMPTY',
    defaultMessage: 'Please select a non-empty file.',
  },
  UPLOAD_FILE_TOO_LARGE: {
    id: 'error.code.UPLOAD_FILE_TOO_LARGE',
    defaultMessage: 'File is too large. Maximum allowed size is 2 MB.',
  },
  UPLOAD_MIME_TYPE_NOT_ALLOWED: {
    id: 'error.code.UPLOAD_MIME_TYPE_NOT_ALLOWED',
    defaultMessage: 'Unsupported file type. Please upload PNG, JPEG, SVG, or WEBP.',
  },
};
